// Generated by Melange

import * as Buhta_cabinet__Kkm from "../../../../models/Kkm.js";
import * as Buhta_cabinet__KkmReregisterModal from "./KkmReregisterModal.js";
import * as Buhta_cabinet__KkmUnregisterModal from "./KkmUnregisterModal.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KkmSettingsOfd(Props) {
  let kkm = Props.kkm;
  let org = Props.org;
  Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const match = React.useState(function () {
    return false;
  });
  const setShowReregisterModal = match[1];
  const match$1 = React.useState(function () {
    return false;
  });
  const setShowUnregisterModal = match$1[1];
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_components__Text.H2.make, {
              children: kkm.name
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-asphalt",
                  children: "Оператор ОФД"
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  children: Buhta_cabinet__Kkm.Provider.toString(kkm.ofd_provider_id)
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-asphalt",
                  children: "Модель"
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  children: "Бухта 1.0"
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-asphalt",
                  children: "Год выпуска"
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  children: "2024"
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-asphalt",
                  children: "Серийный номер"
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  children: kkm.serial_num
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-asphalt",
                  children: "Рег. номер"
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  children: kkm.ofd_register_num
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-asphalt",
                  children: "Адрес ККМ"
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  children: kkm.address_street + (", " + (kkm.address_street1 + (", " + kkm.address_street2)))
                })
              ],
              className: "grid grid-cols-[max-content,_max-content] gap-x-4 gap-y-2 mt-6"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx("img", {
                      alt: "contract",
                      src: StaticAsset.src("/static/icons/contract-gray-16.svg")
                    }),
                    JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                      children: "Скачать регистрационную карточку"
                    })
                  ],
                  className: "flex gap-2 px-3 py-2 border border-gray-main rounded"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                        children: "Перерегистрировать"
                      }),
                      className: "px-3 py-2 border border-gray-main rounded",
                      onClick: (function (param) {
                        Curry._1(setShowReregisterModal, (function (param) {
                          return true;
                        }));
                      })
                    }),
                    JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                        className: "text-alert",
                        children: "Снять кассу с учета"
                      }),
                      className: "px-3 py-2 border border-gray-main rounded",
                      onClick: (function (param) {
                        Curry._1(setShowUnregisterModal, (function (param) {
                          return true;
                        }));
                      })
                    })
                  ],
                  className: "mt-2 flex justify-between"
                })
              ],
              className: "mt-6 items-center"
            })
          ],
          className: "bg-white w-full lg:w-140.5 p-6 lg:p-10 rounded-sm shadow-card"
        }),
        className: "px-4 py-6 lg:px-0 w-full flex justify-center"
      }),
      match[0] ? JsxRuntime.jsx(Buhta_cabinet__KkmReregisterModal.make, {
          onClose: (function (param) {
            Curry._1(setShowReregisterModal, (function (param) {
              return false;
            }));
          }),
          kkm: kkm
        }) : null,
      match$1[0] ? JsxRuntime.jsx(Buhta_cabinet__KkmUnregisterModal.make, {
          onClose: (function (param) {
            Curry._1(setShowUnregisterModal, (function (param) {
              return false;
            }));
          }),
          kkm: kkm,
          org: org
        }) : null
    ]
  });
}

const make = KkmSettingsOfd;

export {
  make,
}
/* Buhta_cabinet__Kkm Not a pure module */
